import script from "./input.vue?vue&type=script&lang=ts&setup=true"
export * from "./input.vue?vue&type=script&lang=ts&setup=true"

import "./input.vue?vue&type=style&index=0&id=14cbdc76&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14cbdc76"]])

export default __exports__